import { ErrorData } from '@b2chat/chat-center-sdk';
import { Box } from '@material-ui/core';
import { updateChatState } from '@src/reducers/chats';
import { requestConverTagsError, toggleTagAssign } from '@src/reducers/tags';
import { activeChatSelector } from '@src/selectors/chats';
import { getConverTags, getConverTagsListViewState } from '@src/selectors/tags';
import {
  assignChatTagPOST,
  deleteChatTagPOST,
} from '@src/services/tags.service';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import AddTag from '../AdminHome/Tags/AddTag';
import { AnyTag } from '../AdminHome/Tags/types';
import { getOldTagData } from '../AdminHome/Tags/utils';

type AddConverTagButtonProps = {
  withoutLabel?: boolean;
  position?: 'left' | 'under' | 'over' | 'overRight';
  grayButton?: boolean;
  onAssigned: (tag: AnyTag, capiEvent: boolean) => void;
  currentCAPIEvents: string[];
};

// Note: the endpoint /services/tags/search/{botId}/{chatId} doesn't have pagination
const AddConverTagButton: React.FC<AddConverTagButtonProps> = ({
  withoutLabel = false,
  position = 'over',
  grayButton,
  onAssigned,
  currentCAPIEvents = [],
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  const dispatch = useDispatch();

  const tags = useSelector(getConverTags);
  const { chatId } = useSelector(getConverTagsListViewState);
  const chat = useSelector(activeChatSelector);
  const onUpdateTag = async (
    curTag: AnyTag,
    checked: boolean,
    capiEvent: boolean
  ) => {
    curTag.assigned = checked;
    const tag = getOldTagData(curTag);

    if (checked) {
      try {
        dispatch(toggleTagAssign({ tagName: tag.tagName, checked: true }));
        const tagPayload = { ...tag };
        if (!capiEvent) delete tagPayload.conversionType;
        await assignChatTagPOST({ chatId, tag: tagPayload });
        onAssigned(curTag, capiEvent);
        if (capiEvent) {
          const conversionTypes =
            tag.conversionType === 'PURCHASE' ? ['LEAD', 'PURCHASE'] : ['LEAD'];
          dispatch(updateChatState({ id: chatId, conversionTypes }));
        }
      } catch (error) {
        dispatch(requestConverTagsError(error as ErrorData));
        dispatch(toggleTagAssign({ tagName: tag.tagName, checked: false }));
      }
    } else {
      try {
        dispatch(toggleTagAssign({ tagName: tag.tagName, checked: false }));
        const tagPayload = { ...tag };
        if (!capiEvent) delete tagPayload.conversionType;
        await deleteChatTagPOST({ chatId, tag: tagPayload });
      } catch (error) {
        dispatch(requestConverTagsError(error as ErrorData));
        dispatch(toggleTagAssign({ tagName: tag.tagName, checked: true }));
      }
    }
  };

  return (
    <Box mt="4px" textAlign="center">
      <AddTag
        tags={tags}
        label={
          withoutLabel
            ? ''
            : formatMessage({ id: 'Tags.console.conver.addButton.label' })
        }
        title={formatMessage({
          id: 'Tags.console.conver.addButton.list.title',
        })}
        placeholder={formatMessage({ id: 'TagSelector.Header' })}
        handleUpdateTag={onUpdateTag}
        position={position}
        bgColor="#F4F4F5"
        grayButton={grayButton}
        currentCAPIEvents={currentCAPIEvents}
        enableCAPIEvents={!!chat?.originatedFromAd}
      />
    </Box>
  );
};

export default AddConverTagButton;
